import { Amplify } from 'aws-amplify';

// =============================================================================
// Required Environment Variables
// =============================================================================

const getRequiredEnv = (name: string): string => {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(`${name} environment variable is required`);
  }
  return value;
};

const COGNITO_USER_POOL_ID = getRequiredEnv('VITE_COGNITO_USER_POOL_ID');
const COGNITO_USER_POOL_CLIENT_ID = getRequiredEnv('VITE_COGNITO_USER_POOL_CLIENT_ID');
const COGNITO_DOMAIN = getRequiredEnv('VITE_COGNITO_DOMAIN');
const CMS_WEBSITE_URL = getRequiredEnv('VITE_CMS_WEBSITE_URL');

// Get the current origin for redirect URLs
const currentOrigin = window.location.origin;

// =============================================================================
// Amplify Configuration
// =============================================================================

const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: COGNITO_USER_POOL_ID,
      userPoolClientId: COGNITO_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: COGNITO_DOMAIN,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [
            currentOrigin,  // Use current origin (localhost:3000, localhost:5173, etc.)
            CMS_WEBSITE_URL
          ],
          redirectSignOut: [
            currentOrigin,  // Use current origin (localhost:3000, localhost:5173, etc.)
            CMS_WEBSITE_URL
          ],
          responseType: 'code'
        },
        email: true,
        username: false
      }
    }
  }
};

Amplify.configure(amplifyConfig);

export default amplifyConfig;
